/* Endorsed by creators: switch creator, play a story.
   Scoped per section so several can sit on one page, and re-run on
   shopify:section:load so it keeps working while editing in the theme editor. */
(function () {
  'use strict';

  function setup(root) {
    if (!root || root.dataset.creatorsReady) return;
    root.dataset.creatorsReady = '1';

    root.querySelectorAll('.tsc-creators__story[data-poster]').forEach(function (story) {
      var poster = story.getAttribute('data-poster');
      if (poster) story.style.backgroundImage = 'url(' + poster + ')';
    });

    var tabs = root.querySelectorAll('.tsc-creators__tab');
    var panels = root.querySelectorAll('.tsc-creators__panel');

    function stopAll(scope) {
      scope.querySelectorAll('.tsc-creators__story video').forEach(function (video) {
        video.pause();
        video.removeAttribute('src');
        video.load();
        video.parentElement.classList.remove('tsc-creators__story--playing');
      });
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        stopAll(root);
        tabs.forEach(function (t) { t.classList.remove('tsc-creators__tab--active'); });
        tab.classList.add('tsc-creators__tab--active');
        panels.forEach(function (p) { p.classList.remove('tsc-creators__panel--active'); });
        var panel = root.querySelector('[data-panel="' + tab.getAttribute('data-creator') + '"]');
        if (panel) panel.classList.add('tsc-creators__panel--active');
      });
    });

    root.querySelectorAll('.tsc-creators__story').forEach(function (story) {
      story.addEventListener('click', function () {
        var src = story.getAttribute('data-video');
        if (!src) return;
        var video = story.querySelector('video');

        if (story.classList.contains('tsc-creators__story--playing')) {
          if (video) { video.pause(); video.removeAttribute('src'); video.load(); }
          story.classList.remove('tsc-creators__story--playing');
          return;
        }

        stopAll(story.closest('.tsc-creators__panel') || root);

        if (!video) {
          video = document.createElement('video');
          video.setAttribute('playsinline', '');
          video.setAttribute('loop', '');
          video.setAttribute('preload', 'none');
          story.appendChild(video);
        }
        video.src = src;
        video.play();
        story.classList.add('tsc-creators__story--playing');
      });
    });
  }

  function init(scope) {
    (scope || document).querySelectorAll('.tsc-creators').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
